import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	qrCodeGeneratedContainer: {
		padding: "32px 16px",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0])
	},
	qrCodeImageContainer: {
		width: 250,
		height: 250,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50])
	},
	qrCodeImage: {
		filter: "grayscale(100%)",
		width: "100%",
		maxWidth: "100%",
		imageRendering: "pixelated"
	},
	qrCodeContainer: {
		maxWidth: 275
	},
	tutorialScreenshot: {
		maxWidth: 300
	},
	cancelButton: {
		color: colors.gray[400]
	}
})

export default useStyles
